import React from "react";
import {FormattedMessage, injectIntl} from "react-intl";
import i18n from "../../../main/i18n";

export default injectIntl(props => {

  const msg = i18n.getMsg(props.intl);
  const customerName = msg(`customer.${process.env.REACT_APP_CUSTOMER}`);

  return (
    <React.Fragment>

      <h1 className="page-title">
        <FormattedMessage id="about.title" defaultMessage="About"/>
      </h1>

      <p>
        <FormattedMessage id="about.body"
                          defaultMessage="This web application was built for the purpose to make it easier for people to submit required paperwork (evidence). We want to provide a convenient and time saving alternative to existing options."/>
      </p>

      <p>
        <strong>
          <FormattedMessage id="about.area"
                            defaultMessage="Evidence submissions cover only {customerName} area at the moment."
                            values={{customerName: customerName}}/>
        </strong>
      </p>

    </React.Fragment>
  );
})
